'use strict';

exports.__esModule = true;

var _inject = require('./inject');

var _inject2 = _interopRequireDefault(_inject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = (0, _inject2['default'])('state');


//////////////////
// WEBPACK FOOTER
// ./~/react-decoration/lib/decorators/functions/injectState.js
// module id = 575
// module chunks = 1